import {
  createStickyNote,
  deleteStickyNote,
  editStickyNote,
  getAllStickyNotes,
} from "../api";
import { request, success, failure, STICKY_NOTES } from "./utilities";

export function createNewStickyNote(data, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(STICKY_NOTES.CREATE_STICKY_NOTE_REQUEST));
    createStickyNote(data).then(
      (response) => {
        if (response.data.Succeeded === true) {
          dispatch(
            success(STICKY_NOTES.CREATE_STICKY_NOTE_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(response.data.message, "success");
          }
        } else {
          dispatch(
            failure(
              STICKY_NOTES.CREATE_STICKY_NOTE_FAILURE,
              response.data.message
            )
          );
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            STICKY_NOTES.CREATE_STICKY_NOTE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function editExistStickyNote(id, data, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(STICKY_NOTES.EDIT_STICKY_NOTE_REQUEST));
    editStickyNote(id, data).then(
      (response) => {
        if (response.data.Succeeded === true) {
          dispatch(
            success(STICKY_NOTES.EDIT_STICKY_NOTE_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(response.data.message, "success");
          }
        } else {
          dispatch(
            failure(
              STICKY_NOTES.EDIT_STICKY_NOTE_FAILURE,
              response.data.message
            )
          );
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            STICKY_NOTES.EDIT_STICKY_NOTE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getStickNotesList(id) {
  return (dispatch) => {
    dispatch(request(STICKY_NOTES.GET_ALL_STICKY_NOTES_REQUEST));
    getAllStickyNotes(id).then(
      (response) => {
        if (response.data.Succeeded === true) {
          dispatch(
            success(
              STICKY_NOTES.GET_ALL_STICKY_NOTES_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              STICKY_NOTES.GET_ALL_STICKY_NOTES_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            STICKY_NOTES.GET_ALL_STICKY_NOTES_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function deleteSingleStickyNote(id, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(STICKY_NOTES.DELETE_STICKY_NOTE_REQUEST));
    deleteStickyNote(id).then(
      (response) => {
        if (response.data.Succeeded) {
          dispatch(
            success(STICKY_NOTES.DELETE_STICKY_NOTE_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(response.data.message, "success");
          }
        } else {
          dispatch(
            failure(
              STICKY_NOTES.DELETE_STICKY_NOTE_FAILURE,
              response.data.message
            )
          );
          if (Notification) {
            Notification(response.data.message, "success");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            STICKY_NOTES.DELETE_STICKY_NOTE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
